import React from 'react'

function Footer() {
  return (
    <div className='lg:fixed lg:bottom-0 z-10 w-full py-3 text-white  bg-dark-gray px-8 mx-auto text-center'>
      <p className='text-lg font-semibold'>
        Copyright 2023 <br /> Universitas Pendidikan Indonesia
      </p>
    </div>
  )
}

export default Footer
